<template>
    <div :class="['editable-cell1', background ? 'bg' : 'none']">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input 
            style="width: 100%;"
            :autoFocus="true"
            class="text"
            size="small"
            v-model.trim="val"
            @blur="blur"
            @pressEnter="e => e.target.blur()"
          />
        </div>
        <div class="editable-cell-text-wrapper1" :class="color"  @click="edit" v-else>
          <a-spin :spinning="loading" size="small" class="spinning-block1">
            <span :class="color" class="spanClass">
              {{ text }}
            </span>
          </a-spin>
        </div>
    </div>
</template>

<script>
export default {
  props:['text','item', 'name', 'actions','background','len','precision'],
  data(){
    return {
      val:undefined,
      target:null,
      editable:false,
      loading:false,
      isEdit: false
    }
  },
  computed:{
    color(){
      const {item,name,text} = this
      const {content,percentage,maxLimitValue,minLimitValue,maxValue,minValue,mixPercentage} = item
      let contentVal = content === '' || content === null ? content : Number(content).toFixed(this.len)
      if(mixPercentage || mixPercentage === 0){
        contentVal = mixPercentage === '' || mixPercentage === null ? mixPercentage : Number(mixPercentage).toFixed(this.len)
      }
      const val =  text === '' || text === null ? text : Number(text).toFixed(this.len)
      const red = (val === contentVal || text === percentage) && (
        (name === 'maxLimitValue' && maxLimitValue !== '') ||
        (name === 'maxValue' && maxValue !== '')
        )
      const green = (val === contentVal || text === percentage) && ((name === 'minValue' && minValue !== '') || (name === 'minLimitValue' && minLimitValue !== ''))
      return {
        red,green,redBg:red,greenBg:green,blue: this.isEdit
      }
    },
  },
  methods:{
    blur(){
      this.editable = false
      let target = {...this.item}
      if(this.text === this.val) return
      target[this.name] = this.val
      this.target = target
      this.$nextTick(()=>{
        this.updates()
      })
    },
    async updates(){
      this.target={...this.target,name:''}
      this.$nextTick(async() => {
        if(this.actions){
          this.loading = true
          await this.actions(this.target,true)
          this.loading = false
          this.$emit('blur',this.target)
        } else {
          this.loading = false
          this.$emit('blur',this.target)
        }
      })
    },
    edit(){
      if(this.item.isRawDelete != 1){
        this.editable = true
        this.isEdit = true
        this.val = this.text
      }
    },
  }
}
</script>